export default __webpack_public_path__ + "static/media/ftresonance.463cc30c.png";